import _ from '../../libs/lodash';
import filterConstansts from './constants';

const filterStaticItemsByProperty = {
  text: {
    property: filterConstansts.PROPERTY.text,
    label: __('filter_option_task_name'),
    placeholder: __('filter_placeholders_task_name'),
    template: 'input',
  },

  type: {
    property: filterConstansts.PROPERTY.type,
    label: __('filter_option_type_label'),
    placeholder: __('filter_task_type_any'),
    template: 'dropdown',
  },

  status: {
    property: filterConstansts.PROPERTY.status,
    label: __('filter_option_status_label'),
    placeholder: __('filter_task_status_any'),
    template: 'dropdown',
  },

  priority: {
    property: filterConstansts.PROPERTY.priority,
    label: __('filter_option_priority_label'),
    placeholder: __('filter_task_priority_any'),
    template: 'dropdown',
  },

  color: {
    property: filterConstansts.PROPERTY.color,
    label: __('filter_option_color_label'),
    placeholder: __('filter_task_color_any'),
    template: 'dropdown',
  },

  rangeDate: {
    property: filterConstansts.PROPERTY.rangeDate,
    label: __('filter_option_cost_range_label'),
    placeholder: __('filter_option_cost_range'),
    template: 'input',
  },

  startDate: {
    property: filterConstansts.PROPERTY.startDate,
    label: __('filter_option_start_date_label'),
    placeholder: __('filter_option_start_date'),
    template: 'input',
  },

  endDate: {
    property: filterConstansts.PROPERTY.endDate,
    label: __('filter_option_end_date_label'),
    placeholder: __('filter_option_end_date'),
    template: 'input',
  },

  creationDate: {
    property: filterConstansts.PROPERTY.creationDate,
    label: __('filter_option_created_at_label'),
    placeholder: __('filter_option_created_at'),
    template: 'input',
  },

  overdue: {
    property: filterConstansts.PROPERTY.overdue,
    label: __('filter_option_overdue_label'),
    template: 'switch',
    tooltip: __('overdue_filter_tooltip'),
  },

  comment: {
    property: filterConstansts.PROPERTY.comment,
    label: __('filter_option_comment_label'),
    placeholder: __('filter_placeholders_comment'),
    template: 'input',
  },

  date: {
    property: filterConstansts.PROPERTY.date,
    label: __('filter_option_date_label'),
    placeholder: __('filter_option_date'),
    template: 'input',
  },

  time: {
    property: filterConstansts.PROPERTY.time,
    label: __('filter_option_time_label'),
    template: null,
  },

  gantt_id: {
    property: filterConstansts.PROPERTY.gantt_id,
    label: __('filter_option_gantt_id_label'),
    placeholder: __('filter_task_gantt_id_any'),
    placeholderSingle: __('filter_task_gantt_id_single'),
    template: 'dropdown',
  },

  portfolio_id: {
    property: filterConstansts.PROPERTY.portfolio_id,
    label: __('filter_option_portfolios_label'),
    placeholder: __('filter_task_gantt_id_any'),
    template: 'dropdown',
  },

  assignee: {
    property: filterConstansts.PROPERTY.assignee,
    label: __('filter_option_assignee_label'),
    placeholder: __('filter_task_assignee_any'),
    template: 'dropdown',
  },

  resource_id: {
    property: filterConstansts.PROPERTY.resource_id,
    label: __('filter_option_resource_id_label'),
    placeholder: __('filter_task_resource_id_any'),
    template: 'dropdown',
  },

  reporter: {
    property: filterConstansts.PROPERTY.reporter,
    label: __('filter_option_reporter_label'),
    placeholder: __('filter_task_reporter_any'),
    template: 'dropdown',
  },

  realResources: {
    property: filterConstansts.PROPERTY.resource_id,
    label: __('filter_option_resource_id-timeloglist_label'),
    placeholder: __('filter_task_resource_id_any'),
    template: 'dropdown',
  },

  assigneeByGanttIDs: {
    property: filterConstansts.PROPERTY.assignee,
    label: __('filter_option_assignee_label'),
    placeholder: __('filter_task_assignee_any'),
    template: 'dropdown',
  },

  owner_id: {
    property: filterConstansts.PROPERTY.owner_id,
    label: __('filter_option_owners_label'),
    placeholder: __('filter_task_assignee_any'),
    template: 'dropdown',
  },

  project_status: {
    property: filterConstansts.PROPERTY.project_status,
    label: __('filter_option_project_status_label'),
    placeholder: __('filter_task_assignee_any'),
    template: 'dropdown',
  },
};

export default filterStaticItemsByProperty;
